// HubSpot rendert die Formulare in einem cross-origin iframe. Der Parent kann weder
// Felder lesen noch schreiben, er bekommt nur die Events des Embeds. Die Vorbelegung
// der Felder passiert deshalb serverseitig, siehe inc/hubspot.php.
//
// Bleibt hier: nach dem Absenden zur Bestaetigung scrollen. Nur wenn das Formular
// oberhalb des Viewports liegt - sonst springt die Seite ohne Not.
document.addEventListener('hs-form-event:on-submission:success', function (event) {
    var frame = event.target && event.target.closest
        ? event.target.closest('.hs-form-frame')
        : null;

    if (!frame) {
        frame = document.querySelector('.hs-form-frame');
    }

    if (!frame) {
        return;
    }

    var box = frame.getBoundingClientRect();

    if (box.top >= 0) {
        return;
    }

    window.scrollTo({
        top: box.top + window.pageYOffset - 100,
        behavior: 'smooth',
    });
});
